module.exports = __webpack_public_path__ + "img/security-section-introduction.7ec663b0.svg";